.shimmerText {
    background: linear-gradient(
        90deg,
        currentColor,
        var(--mantine-color-gneis-3),
        currentColor
    );
    background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% 100%;
    animation: shimmer 1s linear infinite;
}

@keyframes shimmer {
    0% {
        background-position: 200% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}
